import { Route } from '@philips-emr/hpms-provider-accreditation-commons';
import Controller, { OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';

import { CallCategoriesAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import './call-controller.css';

interface CallCategory {
  nrSeqCategory: number,
  dsCategory: string,
}

@Controller({ fragment: FragmentNames.CALL_CATEGORIES })
class CallCategoriesController extends BaseController {

  @OnSelectItem(Aliases.DECK_CATEGORIES)
  onSelectitemDeckCategories(event: SelectItemEvent<CallCategory>): void {
    const { nrSeqCategory } = event.item;
    this.historyService.push(Route.NEW_CALL, { nrSeqCategory });
  }
}

export {
  CallCategoriesController,
};
